import { jsx } from "react/jsx-runtime";
import PhotoIcon from "@mui/icons-material/Photo";
import { validateTidalLicense } from "../../base/index.js";
function Photo(props) {
  return /* @__PURE__ */ jsx(
    PhotoIcon,
    {
      "data-testid": "Photo",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Photo",
      "data-tidal-icon-meta": "devices,photos"
    }
  );
}
Photo.tidalIconMeta = {
  categories: "devices,photos",
  name: "Photo"
};
validateTidalLicense();
export {
  Photo
};
//# sourceMappingURL=Photo.js.map
